import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import './FaqAccordion.css';

// Question-and-answer list shared by the FAQ page and the home page. Answers are rendered as plain
// text (never HTML), so whatever an admin types cannot inject markup into the site.
const FaqAccordion = ({ faqs, defaultOpenFirst = false }) => {
    const [openId, setOpenId] = useState(defaultOpenFirst && faqs[0] ? faqs[0]._id : null);

    return (
        <ul className="faq-acc">
            {faqs.map(faq => {
                const open = openId === faq._id;
                return (
                    <li key={faq._id} className={`faq-acc__item ${open ? 'is-open' : ''}`}>
                        <button
                            type="button"
                            className="faq-acc__question"
                            aria-expanded={open}
                            aria-controls={`faq-answer-${faq._id}`}
                            onClick={() => setOpenId(open ? null : faq._id)}
                        >
                            <span>{faq.question}</span>
                            <ChevronDown size={20} aria-hidden="true" />
                        </button>
                        <div id={`faq-answer-${faq._id}`} className="faq-acc__answer" role="region" hidden={!open}>
                            <p>{faq.answer}</p>
                        </div>
                    </li>
                );
            })}
        </ul>
    );
};

export default FaqAccordion;
